import styles from './css/ResetPassword.css';

import React from 'react';
import { Link } from 'react-router';
import { TextInput, Button, Icon } from '@tcc/crate';
import { getMessage } from '../../i18n/i18nWrapper';
import PropTypes from 'prop-types';

export const ResetPassword = ({email, errorText, isResetFetching, resetPassword, setEmail}) => {

  function formResetPassword(e) {
    e.preventDefault();
    resetPassword();
  }

  let errorLabel;
  if (errorText === 'emailNotFound') {
    errorLabel = (
      <span>
        {getMessage('resetPasswordMessages.nonexistentEmail')}
        <Link className={styles.link} href={`${window.location.pathname}#/register`}>
          {getMessage('resetPasswordMessages.signup')}
        </Link>
      </span>
    );
  } else if (errorText === 'serverError') {
    errorLabel = getMessage('resetPasswordMessages.serverError');
  }

  return (
    <div className={styles.container}>
      <div className={styles.logoContainer} data-test-id="climate-fv-logo">
        <Icon className={styles.logo} glyph={Icon.set.CLIMATE_PORTAL_COLOR} />
      </div>

      <div>
        <p className={styles.title} data-test-id="reset-password-title">
          {getMessage('resetPasswordMessages.resetPassword')}
        </p>
        <p className={styles.description} data-test-id="reset-password-blurb">
          {getMessage('resetPasswordMessages.blurb')}
        </p>
      </div>

      <form className={styles.resetPasswordForm} onSubmit={formResetPassword}>
        <TextInput
          error={errorLabel}
          id="resetEmail"
          label={getMessage('resetPasswordMessages.inputLabel')}
          name="email"
          onChange={setEmail}
          testId="email"
          value={email} />

        <div>
          <Button
            className={styles.button}
            isLoading={isResetFetching}
            mode="primary"
            testId="reset-password"
            type="submit">
            {getMessage('resetPasswordMessages.button')}
          </Button>
        </div>
      </form>

      <div>
        <Link
          className={styles.knowPassword}
          data-test-id="back-to-login"
          href={`${window.location.pathname}#/`}
        >
          {getMessage('resetPasswordMessages.knowPassword')}
        </Link>
      </div>
    </div>
  );
};

ResetPassword.propTypes = {
  email: PropTypes.string,
  errorText: PropTypes.string.isRequired,
  isResetFetching: PropTypes.bool.isRequired,
  resetPassword: PropTypes.func.isRequired,
  setEmail: PropTypes.func.isRequired
};

export default ResetPassword;
